module.exports = __webpack_public_path__ + "static/media/daiict.bd62bf45.png";